import CRUDService from './CRUDService';

export interface AllowedEmailDomain {
  _id: string;
  university_id: string;
  domain: string;
  fromEmailAlias?: boolean;
  verifiedDomainSend?: boolean;
  domainVerifiedAt?: string;
  sesVerificationToken?: string;
  sesDkimTokens?: string[];
}
export default new CRUDService<AllowedEmailDomain>('/v1/admin/allowed-email-domains');
